import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { useT } from "../../i18n/I18nProvider";

const SPANS = [
  "md:col-span-4",
  "md:col-span-2",
  "md:col-span-3",
  "md:col-span-3",
];

export const HomeServices = () => {
  const t = useT();
  const services = t("home.services.items");

  return (
    <section
      className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-20 md:py-40"
      data-testid="home-services"
    >
      <div className="grid lg:grid-cols-12 gap-6 md:gap-10 items-end mb-10 md:mb-16">
        <div className="lg:col-span-7">
          <Reveal>
            <div className="overline mb-4 md:mb-5">
              {t("home.services.overline")}
            </div>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-display text-4xl sm:text-5xl md:text-7xl leading-[0.95] tracking-tightest">
              {t("home.services.title1")}
              <br />
              <span className="font-editorial text-ink-700">
                {t("home.services.titleEditorial")}
              </span>{" "}
              {t("home.services.title2")}
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:pl-16">
          <Reveal delay={140}>
            <p className="text-[15px] md:text-[16px] text-ink-500 leading-relaxed">
              {t("home.services.paragraph")}
            </p>
            <Link
              to="/servizi"
              className="mt-6 md:mt-8 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.24em] uppercase text-ink-900 underline-grow"
              data-testid="services-link"
            >
              {t("common.vediServizi")} <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-6">
        {services.map((s, i) => {
          const idx = String(i + 1).padStart(2, "0");
          return (
            <Reveal
              key={s.title}
              delay={i * 60}
              className={`${SPANS[i]} card-flat p-6 md:p-10 flex flex-col justify-between min-h-[200px] md:min-h-[240px] group`}
              data-testid={`service-card-${idx}`}
            >
              <div className="flex items-start justify-between">
                <span className="overline">{idx}</span>
                <ArrowUpRight
                  className="w-4 h-4 text-ink-300 group-hover:text-ink-900 transition-colors"
                  strokeWidth={1.6}
                />
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-4xl tracking-tight mt-6 md:mt-8">
                  {s.title}
                </h3>
                <p className="mt-3 md:mt-4 text-[13px] md:text-[14px] text-ink-500 leading-relaxed max-w-md">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
